import * as React from 'react'
import Button from '@mui/material/Button'

import { useCommand } from '~/client/hooks/cqrpc'
import ErrorMessage from '~/client/components/ErrorMessage'
import Form from '~/client/components/Form'
import FormButtonRow from '~/client/components/FormButtonRow'

export default function CommandForm({
  children,
  renderError = true,
  formButtons = true,
  command: commandName,
  onSubmit: _onSubmit,
  onSuccess,
  onFailure,
  onComplete,
  onCancel,
  onReset,
  cancelTo,
  disabled,
  submittable = true,
  submitText,
  submittingText,
  autoFocusSubmitButton,
  ...props
}){
  const command = useCommand(commandName, {
    debug: true,
    onSuccess,
    onFailure,
    onComplete,
  })
  const onSubmit = React.useCallback(
    value => {
      if (!submittable) return
      if (_onSubmit) _onSubmit(value, command)
      else command.call(value)
    },
    [commandName, _onSubmit, command]
  )
  const submitting = command.pending
  disabled = !!(disabled || submitting)
  return <Form {...{onSubmit}}>
    {renderError ? <ErrorMessage error={command.error}/> : null}
    {typeof children === 'function' ? children({command, disabled, submitting}) : children}
    {formButtons
      ? <FormButtonRow {...{
        submitting,
        onCancel,
        onReset,
        cancelTo,
        disabled,
        submittable,
        submitText,
        submittingText,
        autoFocusSubmitButton,
      }}/>
      : null
    }
  </Form>
}
